"use client";

import { useGlobalPreferences } from "@/components/useGlobalPreferences";
import { translate, type TranslationKey } from "@/lib/i18n";

export function useI18n() {
  const locale = useGlobalPreferences().locale;
  return { locale, en: locale === "en", t: (key: TranslationKey) => translate(key, locale) };
}
